export default __webpack_public_path__ + "static/media/DuobkasiuPaslaugos.65bbf08f.svg";